import React from "react";
import PropTypes from "prop-types";
import IncentiveCard from "../IncentiveCard/IncentiveCard";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";

const IncentiveCatalog = ({ 
    incentives, 
    titleText,
    limit = null
  }) => {
  if (!incentives) return <LoadingSpinner />;

  const clonedIncentives = limit ?
    incentives.slice(0, limit) :
    incentives.slice();
  
  const renderCards = clonedIncentives
    ? clonedIncentives.map((incentive, index) => {
        return <IncentiveCard incentive={incentive} key={index} />;
      })
    : null;

  return (
    <div className="row mt-3 mb-3">
      <div className="col-sm-12">
        {titleText && <p className="h3 text-left">{titleText}</p>}
        <div className="d-flex justify-content-center flex-wrap">
          <div className="row justify-content-center">
            {renderCards}
           </div>
        </div>
      </div>
    </div>
  );
};

export default IncentiveCatalog;

IncentiveCatalog.propTypes = {
  incentives: PropTypes.array,
  titleText: PropTypes.element,
  includeTotal: PropTypes.bool,
  limit: PropTypes.number
};
